import { API_URL } from '../../config';

export function checkStatusOfUser(email){
  return fetch(`${API_URL}/pub/v1/user/state?email=${encodeURIComponent(email)}`,{
    method:'GET',
    headers:{
      'Accept':'application/json',
      'Content-Type':'application/json'
    }
  })
  .then((res) => {
    if(res.status === 404){
      return Promise.resolve({ 
        data:{
          active:false,
          emailVerified:false        
        }
      });
    } else {
      return res.json();
    }
  })
  .then((res) => res.data);
}



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImMary/utils.js